import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function TrustSection() {
  const {
    t
  } = useLanguage();
  const trustPoints = [t('trust1'), t('trust2'), t('trust3'), t('trust4'), t('trust5')];
  return <section className="w-full py-24 bg-[#2C1810] text-white relative overflow-hidden" data-id="element-265">
      {/* Subtle gold overlay pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#D4AF37 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-266"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-268">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mb-8" data-id="element-269">
            <svg className="w-8 h-8 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-270">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-271" />
            </svg>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-[#FDF6F0] mb-6" data-id="element-272">
            {t('trust_title')}
          </h2>
          <p className="text-[#D4AF37] font-light text-xl max-w-2xl mx-auto italic font-serif" data-id="element-273">
            {t('trust_quote')}
          </p>
          <p className="text-white/80 font-light mt-4" data-id="element-274">{t('trust_subtitle')}</p>
        </motion.div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12 mb-12" data-id="element-275">
          <ul className="space-y-6" data-id="element-276">
            {trustPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-277">
                <div className="flex-shrink-0 mt-1" data-id="element-278">
                  <svg className="w-6 h-6 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-279">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-280" />
                  </svg>
                </div>
                <span className="text-white/90 font-light text-lg leading-relaxed" data-id="element-281">
                  {point}
                </span>
              </motion.li>)}
          </ul>

          <div className="mt-10 pt-8 border-t border-white/10 text-center" data-id="element-282">
            <p className="font-serif text-2xl text-[#D4AF37]" data-id="element-283">
              {t('trust_footer')}
            </p>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center text-center space-y-6" data-id="element-284">
          <a href="https://eyebrowsiaraoliver.site.agendapro.com/ar/sucursal/34777" target="_blank" rel="noopener noreferrer" className="animate-breathe px-10 py-5 rounded-full bg-gold-gradient text-white font-medium tracking-wide shadow-[0_4px_20px_rgba(212,175,55,0.3)] transition-all hover:shadow-[0_6px_25px_rgba(212,175,55,0.5)] hover:scale-105 text-lg inline-block" data-id="element-285">
            {t('trust_btn')}
          </a>

          <div className="max-w-xl text-white/60 font-light text-sm space-y-2" data-id="element-286">
            <p data-id="element-287">{t('trust_urgency1')}</p>
            <p data-id="element-288">{t('trust_urgency2')}</p>
            <p className="text-[#D4AF37] font-medium" data-id="element-289">{t('trust_urgency3')}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}